var Backbone = require('backbone')
  , _ = require('underscore')
  , tmpl = require('./tmpl.handlebars')
  , enableDialog = require('ui/enableDialog')
  , formUtils = require('@173js/ui/form')
  , ValidateForm = require('widgets/ValidateForm')
  , ued = window.ued || {}
  , EMPTY_CPATCHA_HASH = 663

var View = Backbone.View.extend({
  events: {
    'submit form': 'formSubmitted'
  , 'click .captcha-container': 'fetchAndRenderCaptcha'
  }
, initialize: function(options) {
    options = options || {}
    this.activityInfo = options.activityInfo || {}
    this.resultMessage = options.resultMessage || ''
    this.captchaHash = EMPTY_CPATCHA_HASH
  }
, ajaxSubmitForm: function(dict) {
    var ued = window.ued || {}
      , gameCode = ued.gameCode
      , form = this.$('form')

    formUtils.readonlyForm(form)

    return $.ajax({
      type: 'POST',
      url: '/game-collectVoteData.html',
      dataType:'json',
      data: _.extend({ id: gameCode }, dict, { to_update: +!!dict.to_update })
    }).always(function() {
      formUtils.resumeForm(form)
    }).done(_.bind(function(resp) {
      if (resp.result === 'success') {
        return this.$el.html(resp.msg)
      }

      this.renderFieldErrors(
        _.map(_.values(resp.errorFields), function(message) {
          return { message: message }
        })
      )
    }, this))
    .fail(_.bind(function() {
      this.$el.html('网络发生了错误')
    }))
  }
, showErrors: function(message) {
    var errorBlock = this.$('.error-block')
    errorBlock.html('<b>' + message + '</b>').show()
  }
, hideErrors: function() {
    var errorBlock = this.$('.error-block')
    errorBlock.empty().hide()
  }
, formSubmitted: function(e) {
    e.preventDefault()
    var dict = formUtils.toDict(this.$('form'))
      , HIDE_ERRORS = []

    this.renderFieldErrors(HIDE_ERRORS)

    if (!this.validateForm.validate()) {
      this.renderFieldErrors(this.validateForm.fieldErrors)
      return
    }

    if (!this.validateCaptcha(this.form)) {
      this.validateForm.handleInvalid(
        this.form.find('input[name="captcha"]')
      , '验证码错误'
      )

      this.renderFieldErrors(this.validateForm.fieldErrors)
      return
    }

    this.ajaxSubmitForm(dict)
  }
, fetchMemberInfo: function() {
    return $.getJSON('/game-getMemberInfo.html')
  }
, renderWhenFetchMemberInfo: function(resp) {
    var userData = resp.data || {}
      , info = this.activityInfo

    _.each(['need_account', 'need_address', 'need_server'], function(propName) {
      info[propName] = +info[propName];
    })

    this.$el.html(tmpl(
      _.extend({}, info
        , userData
        , { activityTimeLabel: info.begin_time + ' - ' + info.end_time
          , resultMessage: this.resultMessage
          }
      )
    ))

    this.form = this.$('form')
    this.validateForm = new ValidateForm({
      form: this.form
    })

    this.fetchAndRenderCaptcha()
  }
, render: function() {
    this.$el.html('加载中...')
    this.fetchMemberInfo()
      .done(_.bind(this.renderWhenFetchMemberInfo, this))
    return this
  }
, renderFieldErrors: function(fieldErrors) {
    // TODO: DRY
    var errorBlock = this.$('.errors-block')
    if (!fieldErrors || !fieldErrors.length) {
      errorBlock.hide()
      return
    }

    errorBlock.empty()

    _.each(fieldErrors, function(x) {
      if (!x.message) { return }
      errorBlock.append('<li>' + x.message + '</li>')
    })

    this.fetchAndRenderCaptcha()

    errorBlock.show()
  }
, fetchAndRenderCaptcha: function() {
    var captchaContainer = this.$('.captcha-container')

    function handleError() {
      captchaContainer.text('网络发生了错误，点击重试')
    }

    return $.ajax({
      url: '/game-captcha.html?refresh=1'
    , dataType:'json'
    , cache: false
    }).done(_.bind(function(resp) {
      if (!resp) { return handleError() }

      var image = resp.url
      captchaContainer.html(
        $('<img>', { height: 50, src: resp.url })
      )
      this.captchaHash = +resp.hash1
    }, this))
    .fail(handleError)
  }
, validateCaptcha: function(form) {
    var inputCaptchValue = $.trim(form.find('input[name="captcha"]').val())
    if (!inputCaptchValue) { return false }

    var INIT_HASH = 0
      , FIRST_CHAR = 0
      , inputCaptchHash = _.reduceRight(
          inputCaptchValue
        , function(memo, value) {
            return memo + value.toLowerCase().charCodeAt(FIRST_CHAR)
          }
        , INIT_HASH
        )

    return inputCaptchHash === this.captchaHash
  }
})

module.exports = enableDialog(View, { title: '有奖活动' })
